<template>
  <div class="profil">
        <!-- main-area -->
        <main class="fix">
            <!-- blog-details-area -->
            <section class="blog__details-area">
                <div class="container">
                    <div class="blog__inner-wrap">
                        <div class="row">
                            <div class="col-70">
                                <div class="blog__details-wrap">
                                    <div class="blog__details-thumb">
                                        <img :src="file_path+form.foto" alt="Apexa" />
                                    </div>
                                    <div class="blog__details-content">
                                        <h2 class="title">{{ form.judul }}</h2>
                                        <div class="blog-post-meta">
                                            <ul class="list-wrap">
                                                <li><span class="blog__post-tag-two" style="text-transform: capitalize;">{{ form.kategori_id }}</span></li>
                                                <li>
                                                    <div class="blog-avatar">
                                                        <div class="avatar-thumb">
                                                            <i style="font-size: 15px;" class="fas fa-user-circle"></i>
                                                        </div>
                                                        <div class="avatar-content">
                                                            <p style="text-transform: capitalize;">{{ form.createBy.toLowerCase() }}</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li><i class="fas fa-calendar-alt"></i>{{convert_tgl(form.createAt)}}</li>
                                            </ul>
                                        </div>
                                        <p v-html="form.isi"></p>
                                        <div class="blog__details-bottom">
                                            <div class="row align-items-center">
                                                <div class="col-md-7">
                                                </div>
                                                <div class="col-md-5">
                                                    <div class="post-share">
                                                        <h5 class="title">Bagikan:</h5>
                                                        <ul class="list-wrap">
                                                            <li>
                                                                <a @click="shareToWhatsApp()" href="javascript:void(0)" target="_blank">
                                                                    <i class="fab fa-whatsapp"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a @click="shareOnFacebook" href="javascript:void(0)" target="_blank">
                                                                    <i class="fab fa-facebook-f"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a @click="shareOnTwitter" href="javascript:void(0)" target="_blank">
                                                                    <i class="fab fa-twitter"></i>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-30">
                                <aside class="blog__sidebar">
                                    <div class="sidebar__widget sidebar__widget-two">
                                        <div class="sidebar__search">
                                            <form action="#">
                                                <input type="text" v-model="cari_value" @keyup="cari_data()" placeholder="Cari Berita" />
                                                <button type="button" style="cursor: default;">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                                                        <path d="M19.0002 19.0002L14.6572 14.6572M14.6572 14.6572C15.4001 13.9143 15.9894 13.0324 16.3914 12.0618C16.7935 11.0911 17.0004 10.0508 17.0004 9.00021C17.0004 7.9496 16.7935 6.90929 16.3914 5.93866C15.9894 4.96803 15.4001 4.08609 14.6572 3.34321C13.9143 2.60032 13.0324 2.01103 12.0618 1.60898C11.0911 1.20693 10.0508 1 9.00021 1C7.9496 1 6.90929 1.20693 5.93866 1.60898C4.96803 2.01103 4.08609 2.60032 3.34321 3.34321C1.84288 4.84354 1 6.87842 1 9.00021C1 11.122 1.84288 13.1569 3.34321 14.6572C4.84354 16.1575 6.87842 17.0004 9.00021 17.0004C11.122 17.0004 13.1569 16.1575 14.6572 14.6572Z" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="sidebar__widget">
                                        <h4 class="sidebar__widget-title">Berita Terkini</h4>
                                        <div class="sidebar__post-list">
                                            <div v-for="berita in list_data" :key="berita.id" class="sidebar__post-item">
                                                <div class="sidebar__post-thumb">
                                                    <a @click="push_berita(berita.id)" href="javascript:void(0);"><img style="height: 70px;" :src="file_path+berita.foto" alt="Apexa" /></a>
                                                </div>
                                                <div class="sidebar__post-content">
                                                    <h5 class="title"><a @click="push_berita(berita.id)" href="javascript:void(0);">{{ getFirstWords(berita.judul) }}</a></h5>
                                                    <span class="date"><i class="flaticon-time"></i>{{ convert_tgl(berita.createAt) }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </aside>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- blog-details-area-end -->
        </main>
        <!-- main-area-end -->
  </div>
</template>

<script>

// import { useMeta } from 'vue-meta'

export default {
  name: 'Berita',

  data () {
    return {
        URL: this.$store.state.url.URL,
        file_path: this.$store.state.url.URL_APP + "uploads/",
        unit_kerja: this.$store.state.UNIT_KERJA,
        cek_load_data : true,
        cek_load_data_list : true,
        form : {
            id : '',
            judul : '',
            sumber : '',
            deskripsi : '',
            kategori_id : '',
            isi : '',
            foto : '',
            unit_kerja : '',
            status : '',
            keterangan : '',
            createBy : '',
            createAt : '',
        },
        list_data: [],
        page_first: 1,
        page_last: 0,
        cari_value: "",
    }
  },

//   setup() {
//     // Initialize with empty object
//     const { meta } = useMeta({
//       title: '',
//       meta: []
//     })
//     return { meta }
//   },

//   watch: {
//     '$route.query.id': {
//       handler(newId) {
//         if (newId) {
//           this.getView();
//         }
//       },
//       immediate: true
//     },
//     'form.judul': {
//       handler(newVal) {
//         this.updateMeta()
//       },
//       immediate: true
//     },
//     'form.foto': {
//       handler(newVal) {
//         this.updateMeta()
//       },
//       immediate: true
//     }
//   },

  methods: {
    getList: function() {
        this.cek_load_data_list = true;
        fetch(this.$store.state.url.URL_BERITA + "viewOPD", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
            data_ke: this.page_first,
            cari_value: this.cari_value,
            unit_kerja : this.unit_kerja
            })
        })
        .then(res => res.json())
        .then(res_data => {
            this.list_data = res_data.data;
            this.page_last = res_data.jml_data;
            this.cek_load_data_list = false;
        });
    },
    getView: function() {
        this.cek_load_data = true;
        fetch(this.$store.state.url.URL_BERITA + "isi_berita", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            },
            body: JSON.stringify({
                id: this.$route.query.id,
            })
        })
        .then(res => res.json())
        .then(res_data => {
            var berita = res_data[0];
            this.form.id = berita.id;
            this.form.createAt = berita.createAt;
            this.form.createBy = berita.createBy;
            this.form.deskripsi = berita.deskripsi;
            this.form.kategori_id = berita.kategori_id;
            this.form.isi = berita.isi;
            this.form.judul = berita.judul;
            this.form.sumber = berita.sumber;
            this.form.foto = berita.foto;
            this.cek_load_data = false;
            // this.updateMetaTags();
            // this.updateOpenGraphTags();
        });
    },
    cari_data : function(){
        this.page_first = 1;
        this.getView();
        this.getList();
    },
    push_berita : function(id){
        this.$router.push('/detail_berita?id='+id);
        this.getView();
    },
    convert_tgl: function(dateString) {
        var date = new Date(dateString);
        var getBulan = date.getMonth() + 1; var bulan = '';
        if (getBulan == '1') {bulan = 'Jan'} 
        else if(getBulan == '2') {bulan = 'Feb'}
        else if(getBulan == '3') {bulan = 'Mar'}
        else if(getBulan == '4') {bulan = 'Apr'}
        else if(getBulan == '5') {bulan = 'Mei'}
        else if(getBulan == '6') {bulan = 'Jun'}
        else if(getBulan == '7') {bulan = 'Jul'}
        else if(getBulan == '8') {bulan = 'Agt'}
        else if(getBulan == '9') {bulan = 'Sep'}
        else if(getBulan == '10') {bulan = 'Okt'}
        else if(getBulan == '11') {bulan = 'Nov'}
        else if(getBulan == '12') {bulan = 'Des'}
        return date.getDate() + " " + bulan + " " + date.getFullYear();
    },
    getFirstWords(html) {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const text = temp.textContent || temp.innerText || '';
        const words = text.trim().split(/\s+/);
        const firstFive = words.slice(0, 3).join(' ');
        return firstFive + (words.length > 3 ? '...' : '');
    },
    // shareToWhatsApp() {
    //   this.updateOpenGraphTags();
    //   const url = `${window.location.origin}/detail_berita?id=${this.form.id}`
    //   const message = `${url}`
      
    //   window.open(
    //     `https://wa.me/?text=${encodeURIComponent(message)}`,
    //     '_blank',
    //     'noopener,noreferrer'
    //   )
    // },
    // shareToWhatsApp() {
    //     const url = `https://diskominfo.konaweselatankab.go.id/share_berita.php?id=${this.form.id}`
    //     const message = `*${this.form.judul}*\n\n${url}`
    //     window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank')
    // },
    // shareOnFacebook() {
    //     const url = encodeURIComponent(`https://diskominfo.konaweselatankab.go.id/share_berita.php?id=${this.form.id}`)
    //     window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, "_blank")
    // },
    // shareOnFacebook() {
    //     this.updateOpenGraphTags();
    //     setTimeout(() => {
    //     const currentPath = window.location.pathname;
    //     const shareUrl = encodeURIComponent(
    //         `${window.location.origin}${currentPath}?id=${this.form.id}`
    //     );
    //     window.open(
    //         `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
    //         "_blank",
    //         "width=600,height=500"
    //     );
    //     }, 300);
    // },
    // shareOnTwitter() {
    //   this.updateTwitterMetaTags();
    //   const text = encodeURIComponent(`${this.form.judul} - ${this.form.deskripsi.substring(0, 100)}...`);
    //   const url = encodeURIComponent(window.location.href);
    //   window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, "_blank");
    // },
    // updateMeta() {
    //   // Ensure we're assigning a proper object
    //   this.meta = {
    //     title: this.form.judul || 'Default Title',
    //     meta: [
    //       { property: 'og:title', content: this.form.judul || '' },
    //       { property: 'og:image', content: this.file_path + (this.form.foto || '') },
    //       { property: 'og:url', content: window.location.href },
    //       { property: 'og:type', content: 'article' }
    //     ].filter(meta => meta.content)
    //   }
    // },
    //  updateOpenGraphTags() {
    //   const baseUrl = window.location.origin;
    //   const currentPath = window.location.pathname;
    //   const fullUrl = `${baseUrl}${currentPath}?id=${this.form.id}`;

    //   document.getElementById("og-url").content = fullUrl;
    //   document.getElementById("og-title").content = this.form.judul;
    //   document.getElementById("og-description").content = this.form.deskripsi;
    //   document.getElementById("og-image").content = this.file_path+this.form.foto;
    // },
    // updateTwitterMetaTags() {
    //   document.querySelector('meta[name="twitter:title"]').content = this.form.judul;
    //   document.querySelector('meta[name="twitter:description"]').content = this.form.deskripsi;
    //   document.querySelector('meta[name="twitter:image"]').content = this.file_path + this.form.foto;
    // },
    // updateMetaTags() {
    //   const baseUrl = 'https://diskominfo.konaweselatankab.go.id';
    //   const currentPath = '/#/detail_berita';
    //   const fullUrl = `${baseUrl}${currentPath}?id=${this.form.id}`;
    //   const imageUrl = this.form.foto ? this.file_path + this.form.foto : `${baseUrl}/assets/img/logokonsel.png`;
    //   const description = this.form.deskripsi || 'Website Resmi Dinas Komunikasi, Informatika & Persandian Kabupaten Konawe Selatan';
    //   const title = this.form.judul || 'Dinas Komunikasi, Informatika & Persandian - Kabupaten Konawe Selatan';

    //   // Update document title
    //   document.title = title;

    //   // Update Open Graph tags
    //   this.updateMetaTag('property', 'og:url', fullUrl);
    //   this.updateMetaTag('property', 'og:title', title);
    //   this.updateMetaTag('property', 'og:description', description);
    //   this.updateMetaTag('property', 'og:image', imageUrl);

    //   // Update Twitter tags
    //   this.updateMetaTag('name', 'twitter:title', title);
    //   this.updateMetaTag('name', 'twitter:description', description);
    //   this.updateMetaTag('name', 'twitter:image', imageUrl);

    //   // Update standard meta tags
    //   this.updateMetaTag('name', 'description', description);

    //   console.log('Meta tags updated:', {
    //     title,
    //     description,
    //     image: imageUrl,
    //     url: fullUrl
    //   });
    // },

    // updateMetaTag(attr, name, content) {
    //   let metaTag = document.querySelector(`meta[${attr}="${name}"]`);
    //   if (!metaTag) {
    //     metaTag = document.createElement('meta');
    //     metaTag.setAttribute(attr, name);
    //     document.head.appendChild(metaTag);
    //   }
    //   metaTag.setAttribute('content', content);
    // },
    // shareToWhatsApp() {
    //   const baseUrl = 'https://diskominfo.konaweselatankab.go.id';
    //   const url = `${baseUrl}/share_berita.php?id=${this.form.id}`;
    //   const message = `${url}`;
    //   window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
    // },

    // shareOnFacebook() {
    //   const baseUrl = 'https://diskominfo.konaweselatankab.go.id';
    //   const url = encodeURIComponent(`${baseUrl}/share_berita.php?id=${this.form.id}`);
    //   window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, "_blank");
    // },
    shareToWhatsApp() {
  const url = `https://diskominfo.konaweselatankab.go.id/share_berita.php?id=${this.form.id}`;
  const message = `${url}`;
  window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
},

shareOnFacebook() {
  const url = encodeURIComponent(`https://diskominfo.konaweselatankab.go.id/share_berita.php?id=${this.form.id}`);
  window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, "_blank");
},

    shareOnTwitter() {
      const baseUrl = 'https://diskominfo.konaweselatankab.go.id';
      const url = encodeURIComponent(`${baseUrl}/share_berita.php?id=${this.form.id}`);
      const text = encodeURIComponent(`${this.form.judul} - ${this.form.deskripsi?.substring(0, 100)}...`);
      window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, "_blank");
    },
// shareToWhatsApp() {
//     const backendDomain = this.$store.state.url.URL_APP;
//     const url = `${backendDomain}share/share_berita?id=${this.form.id}`;
//     const message = `${url}`;
//     window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
//   },

//   shareOnFacebook() {
//     const backendDomain = this.$store.state.url.URL_APP;
//     const url = encodeURIComponent(`${backendDomain}share/share_berita?id=${this.form.id}`);
//     window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, "_blank");
//   }
  },

  mounted () {
    this.getView();
    this.getList();
    this.updateOpenGraphTags();
    // console.log(window.location.href);
    
  }
}
</script>
